import { Component, OnInit, OnDestroy, HostListener, Output, EventEmitter } from '@angular/core'; import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from 'src/app/services/helpers.service';
import { JobcardService } from 'src/app/services/jobcard.service';
import { NewJobcardService } from 'src/app/services/new-jobcard.service';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { WorkshopJobcardQuoteService } from 'src/app/components/modals/workshop-jobcard/workshop-jobcard-quote/workshop-jobcard-quote.service';
import moment from 'moment';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-workshop-active-jobcard-timers',
  templateUrl: './workshop-active-jobcard-timers.component.html',
  styleUrls: ['./workshop-active-jobcard-timers.component.scss']
})
export class WorkshopActiveJobcardTimersComponent implements OnInit, OnDestroy {

  public timers: any[] = [];
  public isCollapsed: boolean = false;
  public isDragging: boolean = false;

  // Position tracking
  public position = { x: 20, y: 20 };
  private dragOffset = { x: 0, y: 0 };
  private dragStartPosition = { x: 0, y: 0 };
  private hasMoved: boolean = false;

  // Timer interval for updating elapsed times
  private tickInterval: any = null;

  // Store calculated durations
  public timerDurations: Map<number, string> = new Map();

  public timerInterval: any;

  // Track if any modal is open
  public hasOpenModal: boolean = false;
  public subscription: Subscription;

  constructor(
    private jobcardService: JobcardService,
    private helpersService: HelpersService,
    private newJobcardService: NewJobcardService,
    private modalService: NgbModal,
    private workshopJobcardQuoteService: WorkshopJobcardQuoteService,
    public broadcastService: BroadcastService,
  ) { }

  ngOnInit() {
    // Load saved position from localStorage
    const savedPosition = localStorage.getItem('jobcard-timers-position');
    if (savedPosition) {
      this.position = JSON.parse(savedPosition);
    }

    // Load collapsed state
    const savedCollapsed = localStorage.getItem('jobcard-timers-collapsed');
    if (savedCollapsed) {
      this.isCollapsed = JSON.parse(savedCollapsed);
    }

    // Monitor modal state changes
    this.modalService.activeInstances.subscribe(instances => {
      this.hasOpenModal = instances.length > 0;
    });

    // Start the tick interval to update durations every second
    this.startTicking();

    this.reloadTimers();
    this.loadTimers();
    this.createSubscription();
  }

  createSubscription() {
    this.subscription = this.broadcastService.getMessage().subscribe((data) => {
      let message = data.message;

      if (message === 'refresh-jobcard-timers') {
        this.loadTimers();
      }

    });
  }


  ngOnDestroy() {
    // Clean up the interval
    if (this.tickInterval) {
      clearInterval(this.tickInterval);
      this.tickInterval = null;
    }
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  // Keyboard shortcuts listener
  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey) {
      switch (event.key.toLowerCase()) {
        case 'h':
          event.preventDefault();
          this.toggleCollapse();
          break;
      }
    }
  }

  reloadTimers() {
    this.timerInterval = setInterval(() => {
      this.loadTimers();
    }, 30000); // Refresh every 30 seconds
  }

  loadTimers() {
    if (this.isShopRideUserOnly()) {
      return;
    }
    this.jobcardService.getActiveJobCardTimers(this.helpersService.getPartnerId()).subscribe(timers => {
      this.timers = timers;
      this.updateAllDurations();
    });
  }

   isShopRideUserOnly() {
    var profile = this.helpersService.getProfileData();
    var roles = profile.UserRoles.filter((x) => {
      return x.PartnerID === this.helpersService.getPartnerId();
    });

    var isAdmin = roles.map((x) => { return x.RoleID; }).indexOf(2) > -1 || profile.IsSuperUser;
    var isManager = roles.map((x) => { return x.RoleID; }).indexOf(3) > -1;
    var isServiceLead = roles.map((x) => { return x.RoleID; }).indexOf(9) > -1;
    var isShopRideAdmin = roles.map((x) => { return x.RoleID; }).indexOf(10) > -1;

    return isShopRideAdmin && !isAdmin && !isManager && !isServiceLead;
  }

  // Start the tick interval
  startTicking() {
    this.tickInterval = setInterval(() => {
      this.updateAllDurations();
    }, 1000); // Update every second
  }

  // Calculate elapsed time for all timers
  updateAllDurations() {
    this.timers.forEach(timer => {
      if (timer.stopping || timer.pausing) return;
      if (timer.isPaused) {
        const duration = this.calculateDuration(moment.utc().format("YYYY-MM-DDTHH:mm:ss"), timer.existingDuration);
        this.timerDurations.set(timer.timerID, duration);
        return;
      } else {
        const duration = this.calculateDuration(timer.startTime, timer.existingDuration);
        this.timerDurations.set(timer.timerID, duration);
      }
    });
  }

  // Calculate duration from UTC start time to now
  calculateDuration(utcStartTime: string, existingDuration: number): string {
    const startTime = new Date(utcStartTime + 'Z'); // Add 'Z' to indicate UTC
    const now = new Date();
    const diffMs = now.getTime() - startTime.getTime() + (existingDuration * 1000);

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  // Get formatted duration for display
  getDuration(timerID: number): string {
    return this.timerDurations.get(timerID) || '00:00:00';
  }

  // Helper to pad single digits with zero
  padZero(num: number): string {
    return num.toString().padStart(2, '0');
  }

  // Toggle collapsed state
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    localStorage.setItem('jobcard-timers-collapsed', JSON.stringify(this.isCollapsed));
  }

  // Hide timers
  hideTimers() {
    this.isCollapsed = true;
    localStorage.setItem('jobcard-timers-collapsed', JSON.stringify(this.isCollapsed));
  }

  // Show timers
  showTimers() {
    this.isCollapsed = false;
    localStorage.setItem('jobcard-timers-collapsed', JSON.stringify(this.isCollapsed));
  }

  // Drag functionality
  onDragStart(event: MouseEvent) {
    this.isDragging = true;
    this.hasMoved = false;
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();

    this.dragOffset.x = event.clientX - rect.left;
    this.dragOffset.y = event.clientY - rect.top;
    this.dragStartPosition = { x: event.clientX, y: event.clientY };

    event.preventDefault();
  }

  @HostListener('window:mousemove', ['$event'])
  onDragMove(event: MouseEvent) {
    if (this.isDragging) {
      // Check if mouse has moved more than 5px (to distinguish from click)
      const deltaX = Math.abs(event.clientX - this.dragStartPosition.x);
      const deltaY = Math.abs(event.clientY - this.dragStartPosition.y);

      if (deltaX > 5 || deltaY > 5) {
        this.hasMoved = true;
      }

      this.position.x = event.clientX - this.dragOffset.x;
      this.position.y = event.clientY - this.dragOffset.y;

      // Keep within viewport bounds
      this.constrainToViewport();
    }
  }

  @HostListener('window:mouseup')
  onDragEnd() {
    if (this.isDragging) {
      this.isDragging = false;

      // If collapsed and didn't move, treat as click to expand
      if (this.isCollapsed && !this.hasMoved) {
        this.showTimers();
      }

      // Save position to localStorage
      localStorage.setItem('jobcard-timers-position', JSON.stringify(this.position));
      this.hasMoved = false;
    }
  }

  // Ensure widget stays within viewport
  constrainToViewport() {
    // Use different dimensions based on collapsed state
    const widgetWidth = this.isCollapsed ? 60 : 320;
    const widgetHeight = this.isCollapsed ? 60 : 100;

    const maxX = window.innerWidth - widgetWidth;
    const maxY = window.innerHeight - widgetHeight;

    this.position.x = Math.max(0, Math.min(this.position.x, maxX));
    this.position.y = Math.max(0, Math.min(this.position.y, maxY));
  }

  getWidgetStyles() {
    return {
      left: `${this.position.x}px`,
      top: `${this.position.y}px`,
      cursor: this.isDragging ? 'grabbing' : 'auto'
    };
  }

  onOpenJobCard(timerData: any, event: MouseEvent) {
    event.stopPropagation();
    if (this.helpersService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(timerData.serviceID, {
        onRefreshEvents: () => {
          this.loadTimers();
        }
      });
      return;
    }

    const modalRef = this.modalService.open(UpdateJobcardComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'jobcard-modal',
    });
    modalRef.componentInstance.jobcard = null;
    modalRef.componentInstance.jobcardID = timerData.serviceID;
    modalRef.componentInstance.partnerID = timerData.partnerID;
    modalRef.result.then(
      (result) => { },
      (onrejected) => {
        this.loadTimers();
      },
    );
  }

  getDurationFormatted(duration: number) {
    return this.workshopJobcardQuoteService.getDurationFormatted(duration);
  }

  isTimerOverdue(timer: any): boolean {
    const startTime = new Date((!timer.endTime ? timer.startTime : moment.utc().format("YYYY-MM-DDTHH:mm:ss")) + 'Z'); // Add 'Z' to indicate UTC
    const now = new Date();
    const diffMs = now.getTime() - startTime.getTime() + (timer.existingDuration * 1000);
    return diffMs > (timer.allocatedJobcardDuraton * 60 * 1000);
  }

  onStopTimer(timerData: any, event: MouseEvent) {
    timerData.stopping = true;
    event.stopPropagation();
    this.jobcardService.stopServiceTimer(timerData.partnerID, timerData.serviceID, timerData.timerID).subscribe(() => {
      // Refresh timers after stopping
      timerData.isPaused = true;
      this.loadTimers();
      this.broadcastService.sendMessage('reload-calendar-events');
    }, err => {
      timerData.stopping = false;
    });
  }

  onPauseTimer(timerData: any, event: MouseEvent) {
    timerData.pausing = true;
    event.stopPropagation();
    this.jobcardService.pauseServiceTimer(timerData.partnerID, timerData.serviceID, timerData.timerID).subscribe(() => {
      // Refresh timers after stopping
      timerData.isPaused = true;
      this.loadTimers();
      this.broadcastService.sendMessage('reload-calendar-events');
    }, err => {
      timerData.isPaused = false;
      timerData.pausing = false;
    });
  }

  onStartTimer(timerData: any, event: MouseEvent) {
    timerData.starting = true;
    event.stopPropagation();
    this.jobcardService.startServiceTimer(timerData.partnerID, timerData.serviceID).subscribe(() => {
      // Refresh timers after stopping
      this.loadTimers();
      this.broadcastService.sendMessage('reload-calendar-events');
    }, err => {
      timerData.starting = false;
    });
  }

}
